(() => {
  if (window.__ttStepsContactReady) return;
  window.__ttStepsContactReady = true;
  let openedModal = null;
  let returnTarget = null;
  let ownsScrollLock = false;

  function close() {
    if (!openedModal) return;
    openedModal.classList.remove('active');
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    const otherPanel = document.querySelector('cart-drawer.active, account-modal.active, #search-modal.active, .contact-modal.active');
    if (ownsScrollLock && !otherPanel && !document.body.classList.contains('tt-navigation-open')) {
      document.body.classList.remove('overflow-hidden');
    }
    openedModal = null;
    ownsScrollLock = false;
    if (returnTarget?.isConnected) returnTarget.focus({ preventScroll: true });
    returnTarget = null;
  }

  // Delegation also handles theme-editor replacements without duplicate listeners.
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const trigger = target.closest('.steps_content_button');
    if (trigger) {
      const modal = trigger.closest('.shopify-section')?.querySelector('.contact-modal') || document.querySelector('.contact-modal');
      if (!modal || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
      event.preventDefault();
      if (openedModal === modal) return;
      if (openedModal) close();
      returnTarget = trigger;
      openedModal = modal;
      ownsScrollLock = !document.body.classList.contains('overflow-hidden');
      modal.classList.add('active');
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      if (!modal.hasAttribute('aria-label') && !modal.hasAttribute('aria-labelledby')) {
        const title = modal.querySelector('.contact-modal__title');
        if (title) modal.setAttribute('aria-label', title.textContent.trim());
      }
      if (!modal.hasAttribute('tabindex')) modal.setAttribute('tabindex', '-1');
      modal.querySelectorAll('.close_modal_element:not(button):not(a[href])').forEach(element => {
        element.setAttribute('role', 'button');
        element.setAttribute('tabindex', '0');
      });
      document.body.classList.add('overflow-hidden');
      const input = modal.querySelector('input:not([type="hidden"]), textarea, button') || modal;
      if (typeof trapFocus === 'function') trapFocus(modal, input);
      else input.focus({ preventScroll: true });
      return;
    }
    const closer = target.closest('.modal__overlay, .close_modal_element');
    if (closer && closer.closest('.contact-modal') === openedModal && openedModal) {
      event.preventDefault();
      close();
    }
  });
  document.addEventListener('keydown', event => {
    if (!openedModal || !openedModal.contains(event.target)) return;
    const closeLink = event.target.closest?.('.close_modal_element[role="button"]');
    if (closeLink && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      if (!event.repeat) closeLink.click();
    }
  });
  document.addEventListener('keyup', event => {
    if (event.key === 'Escape' && openedModal) close();
  });
  document.addEventListener('shopify:section:unload', event => {
    if (openedModal && (event.target === openedModal || event.target.contains(openedModal))) close();
  });
})();
